/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { get } from "lodash";
import classname from "classnames";
import { getCompanyToken } from "../../../apis/auth";
import { getRememberInfo } from "../../../utils/rememberMe";
import { useDispatch, useSelector } from "react-redux";
import { apiError, loginUser, setProfile } from "../../../store/actions";
import Button from "../../../components/Button";
import Icon from "../../../components/Icon";
import { viewLoading } from "../../../utils/loading";
import systemAlert from "../../../utils/systemAlert";
import fullLogo from "../../../assets/images/full-logo.svg";

import loginImg01 from "../../../assets/images/login/left_ailgn_01.jpeg"
import loginImg02 from "../../../assets/images/login/left_ailgn_02.jpeg"
import loginImg03 from "../../../assets/images/login/left_ailgn_03.jpeg"
import loginImg04 from "../../../assets/images/login/left_ailgn_04.jpeg"
import loginImg05 from "../../../assets/images/login/left_ailgn_05.jpeg"
import loginImg06 from "../../../assets/images/login/right_align_01.jpeg"
import loginImg07 from "../../../assets/images/login/right_align_02.jpeg"
import loginImg08 from "../../../assets/images/login/right_align_03.jpeg"
import { classnames } from "../../../utils/text";
import consultingPopup from "../../../utils/consulting";
import { getPartnerByCode } from "../../../apis/partner/partner";
import { getThroughTaxCompanyCode } from "../../../utils/storage";

const loginImages = [
  {
    img: loginImg01,
    align: 'left'
  },
  {
    img: loginImg02,
    align: 'left'
  },
  {
    img: loginImg03,
    align: 'left'
  },
  {
    img: loginImg04,
    align: 'left'
  },
  {
    img: loginImg05,
    align: 'left'
  },
  {
    img: loginImg06,
    align: 'right'
  },
  {
    img: loginImg07,
    align: 'right'
  },
  {
    img: loginImg08,
    align: 'right'
  },
]

const Login = (props) => {
  const rememberInfo = getRememberInfo();
  const history = useHistory();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((store) => store.Auth);

  const [isRemember, setIsRemember] = useState(get(rememberInfo, "isRemember"));
  const [taxCompnay, setTaxCompnay] = useState(null)


  const _setTaxCompnay = async (code) => {
    const company = await getPartnerByCode(code)
    if (company) setTaxCompnay(company)
  }
  useEffect(() => {
    viewLoading(loading)
  }, [dispatch, loading])

  useEffect(() => {
    if (error) {
      systemAlert(error)
      dispatch(apiError(''))
    }
  }, [dispatch, error])

  useEffect(() => {
    if (getThroughTaxCompanyCode()) {
      _setTaxCompnay(getThroughTaxCompanyCode())
    }
  }, []);


  const [loginInfo, setLoginInfo] = useState({
    id: get(rememberInfo, "id"),
    password: "",
  });
  const [focusInput, setFocusInput] = useState({
    id: false,
    password: false,
  });
  useEffect(() => {
    const companyToken = getCompanyToken();
    dispatch(setProfile());
    if (companyToken) {
      return history.push('/dashboard')
    }
  }, []);

  const handleLogin = () => {
    dispatch(loginUser({
      id: loginInfo.id,
      password: loginInfo.password,
    }, history))
  };

  const setUserInfo = (e) => {
    const { name, value } = e.target;
    setLoginInfo({ ...loginInfo, [name]: value });
  };

  const handleOnFocus = (e) => {
    const { name } = e.target;
    setFocusInput({
      ...focusInput,
      [name]: true,
    });
  };

  const handleOnBlur = (e) => {
    const { name } = e.target;
    setFocusInput({
      ...focusInput,
      [name]: false,
    });
  };
  const [background, setBackground] = useState(null)
  useEffect(() => {
    setBackground(loginImages[Math.floor(Math.random() * loginImages.length)])
  }, [])

  useEffect(() => {
    //console.log('taxCompnay', taxCompnay)
  }, [taxCompnay])
  return (
    <div className="Login auth-wrap">
      <div
        className='login-visual'
      >
        {background &&
          <Icon className={classnames('login-visual-item', `align-${background.align}`)} src={background.img}></Icon>
        }
        <Icon className={'login-logo'} src={fullLogo}></Icon>

      </div>
      <div className="login-form-wrap">
        <div className="login-form">
          {get(taxCompnay, 'logoFile.fileUrl') &&
            <h1 className="has-tax-company-logo">
              <div className="has-tax-company-logo-box">
                <img src={get(taxCompnay, 'logoFile.fileUrl')} className="tax-comapny-logo" alt={get(taxCompnay, 'name')} />
                <small>세무사 {get(taxCompnay, 'ceoName', '')}</small>
              </div>
            </h1>
          }
          {get(taxCompnay, 'name', '') ?
            !get(taxCompnay, 'logoFile.fileUrl') ?
              <h1 className="has-tax-company-logo">
                <label className="tax-comapny-logo">{get(taxCompnay, 'name', '')}</label>
                <small className="smalltext">세무사 {get(taxCompnay, 'ceoName', '')}</small>
              </h1> : <></>
            :
            <h1>로그인</h1>
          }
          <div
            className={classname("focus-password", {
              active: get(focusInput, "password"),
            })}
          />
          <div className="form-wrap">
            <div
              className={classname("input-wrap", {
                active: get(focusInput, "id"),
              })}
            >
              <div className="form-floating">
                <input
                  type="text"
                  id="floatingnameInput"
                  className="form-control"
                  placeholder="&nbsp;"
                  name="id"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      document.getElementById("password-input").focus();
                    }
                  }}
                  defaultValue={get(loginInfo, "id")}
                  onChange={setUserInfo}
                  onFocus={handleOnFocus}
                  onBlur={handleOnBlur}
                />
                <label htmlFor="floatingnameInput">
                  아이디를 입력해주세요.
                </label>
              </div>
            </div>
            <div
              className={classname("divider", {
                none: get(focusInput, "id") || get(focusInput, "password"),
              })}
            />
            <div />
            <div
              className={classname("input-wrap", {
                active: get(focusInput, "password"),
              })}
            >
              <div className="form-floating">
                <input
                  className="form-control"
                  placeholder="&nbsp;"
                  id="password-input"
                  name="password"
                  type="password"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                  onChange={setUserInfo}
                  onFocus={handleOnFocus}
                  onBlur={handleOnBlur}
                />
                <label htmlFor="password-input">비밀번호를 입력해주세요</label>
              </div>
            </div>
          </div>
          <div className="remember-me-wrap">
            <input
              id="remeber"
              type="checkbox"
              checked={isRemember}
              onChange={() => setIsRemember(!isRemember)}
            />
            <label htmlFor="remeber">로그인 정보를 기억할게요</label>
          </div>

          <Button
            size="lg"
            className="w-full mt-15"
            onClick={handleLogin}>
            로그인
          </Button>

          <div className="horizontal-divider" />
          <Link to="sign-up">
            <Button
              size="lg"
              className="w-full mt-24"
              color={'secondary'}
            >
              회원가입
            </Button>
          </Link>
          <div className="inquire-wrap">
            <Link to="forgot-id">아이디 찾기</Link>
            <Link to="forgot-password">비밀번호 찾기</Link>
            <span
              className="cursor-pointer"
              onClick={() => {
                consultingPopup(true)
              }}
            >WeCake에 문의</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
